<template>
  <div class="timer">
    <div class="timer-value">
      {{ currentTime }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Timer",
  components: {},
  props: {
    deadline: {
      type: Number,
      required: true,
    },
    speed: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      timeout: undefined,
      currentTime: this.deadline * this.speed,
    };
  },
  mounted() {
    this.reset();
  },
  computed: {
    value() {
      return this.currentTime;
    },
  },
  methods: {
    reset(val) {
      this.currentTime = (val || this.deadline) * this.speed;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(this.countdown, this.speed);
    },
    stop() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = undefined;
      this.currentTime = 0;
    },
    countdown() {
      this.currentTime -= this.speed;
      if (this.currentTime > 0) {
        this.timeout = setTimeout(this.countdown, this.speed);
      } else {
        this.timeout = undefined;
        this.currentTime = 0;
      }
      this.$emit("remaining-time", this.currentTime);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>